module.exports = __webpack_public_path__ + "img/exit.3edbc516.svg";